import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ThemeProvider as StyledComponentThemeProvider } from 'styled-components';
import MomentUtils from '@date-io/moment';
import { ThemeProvider as MaterialUiThemeProvider } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
//
import GlobalStyle from 'theme/global';
import Router from 'router';
import store from 'store';
import styledComponentTheme from 'theme';
import materialUiTheme from 'theme/material-ui/theme';
import LoadingProvider from 'components/loading-provider';
import ToastProvider from 'lib/toast-provider';
import ModalProvider from 'components/modal-provider';

// Render app
ReactDOM.render(
  <Provider store={store}>
    <StyledComponentThemeProvider theme={styledComponentTheme}>
      <MaterialUiThemeProvider theme={materialUiTheme}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <GlobalStyle />
          <LoadingProvider />
          <ToastProvider />
          <ModalProvider />
          <Router />
        </MuiPickersUtilsProvider>
      </MaterialUiThemeProvider>
    </StyledComponentThemeProvider>
  </Provider>,
  document.getElementById('root')
);
